import Vue from 'common/vue.common.js';
import { MonitorReport } from 'quality/quality_report';
import Env from 'common/env.js';
let exportData = {};

let RandomList = ['appcenter/index.html', 'appcenter/index_single.html', 'appcenter/community.html', 'contentcenter/feeds.html', 'appcenter/service.html']

if(!Env.isCSR) {
    let GlobalMonitorComponents = new MonitorReport('wxgame-components');
    let GlobalMonitorTimer = null;
    let GlobalMonitorReportedList = [];
    let GlobalMonitorList = [];
    
    let RandomMaxNum = 100;
    let isBigPvPage = RandomList.find(function(path) {
        return location.pathname.indexOf(path) > -1
    })

    if(isBigPvPage) {
        RandomMaxNum = 1000
    }
    
    let RandomNum = Math.ceil((Math.random() * RandomMaxNum));
    if(RandomNum === 25 && window.__COMP_BUILD_VERSION__) {
        GlobalMonitorComponents.send([{
            id: 172,
            key1: 'global',
            key2: window.__COMP_BUILD_VERSION__.version,
            key3: window.__COMP_BUILD_VERSION__.version
        }])
    }
    
    function convertToUpperCase(str = ''){
        var arr =  str.split("-");  
        for(var i = 0,len = arr.length;i < len; i++){
            arr[i] = arr[i].charAt(0).toUpperCase() + arr[i].substring(1)
        }
        return arr.join('')
    }
    
    exportData = {
      install() {
        Vue.mixin({
          data() {
            return {
            }
          },
          computed: {
          },
          methods: {
          },
          mounted() {
            try {
                if(RandomNum === 25 && this.$vnode && this.$vnode.componentOptions && this.$vnode.componentOptions.tag) {
                    let tag = this.$vnode.componentOptions.tag;
                    if(tag) {
                        tag = convertToUpperCase(tag);
                        if(GlobalMonitorReportedList.indexOf(tag) == -1 && GlobalMonitorList.indexOf(tag) == -1) {
                            if(window.__COMP_BUILD_VERSION__ && window.__COMP_BUILD_VERSION__.list[tag]) {
                                GlobalMonitorList.push(tag);
        
                                if(GlobalMonitorTimer) {
                                    clearTimeout(GlobalMonitorTimer)
                                    GlobalMonitorTimer = null;
                                }
                                GlobalMonitorTimer = setTimeout(() => {
                                    GlobalMonitorReportedList = GlobalMonitorReportedList.concat(GlobalMonitorList)
                                    let list = [];
                                    for(let item of GlobalMonitorList) {
                                        list.push({
                                            id: 172,
                                            key1: item,
                                            key2: window.__COMP_BUILD_VERSION__.list[item],
                                            key3:  window.__COMP_BUILD_VERSION__.version
                                        })
                                    }
                                    GlobalMonitorList = [];
                                    if(list.length) {
                                        GlobalMonitorComponents.send(list)
                                    }
                                }, 250)
                            }
                        }
                    }
                }
            }catch(e) {
            }
          }
        })
      }
    }
}

export default exportData;